import React from 'react';
import state from '../zviz3/state';
import {ConnectState} from '../zviz3/Connect';
import {checkConditions} from '../helpers/conditions';


class Feedback extends React.Component{

    constructor(props){
        super(props);

        this.setValue = this.setValue.bind(this);
        this.currentValue = null;
    }

    setValue(value){
        if(value !== this.currentValue){
            this.currentValue = value;
            state.set('answers.' + this.props.name, value);
            state.set('explanationOpen', null);
        }
    }

    showFeedback(){
        return checkConditions(this.props.conditions);
    }

    componentDidUpdate(){
        if(! this.showFeedback()){
            this.setValue(null);
        }else{
            // this.setValue(this.props.value);
            // use timeout because there are multiple feedback, and the other might set 
            // value to null after this was set
            setTimeout(() => (this.setValue(this.props.value)), 100);
        }
    }

    render(){
        if(! this.showFeedback()){
            return '';
        }

        return typeof this.props.content === 'function'? this.props.content(): this.props.content;
    }

}

Feedback.defaultProps = {
    content: '',
    conditions: [
        {variable: '', value: '', type: 'equal'}
    ]
}

export default ConnectState(Feedback, 'answers');


// WEBPACK FOOTER //
// ./src/elements/feedback.js